import Vue from 'vue'
import Router from 'vue-router'
import Index from '../pages/index'
import LoginRoute from './login'
import GameRoute from './game'
import BannerRoute from './banner'
import VideoRoute from './video'
import IpBlackRoute from './ip_black'
import RoleRoute from './role'
import personnelRoute from './personnel'
import goodsRoute from './goods'
Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      name: 'index',
      component: Index,
      redirect: '/game',
      children: [
        ...GameRoute,
        ...BannerRoute,
        ...VideoRoute,
        ...IpBlackRoute,
        ...RoleRoute,
        ...personnelRoute,
        ...goodsRoute
      ]
    },
    ...LoginRoute
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js